module.exports = __webpack_public_path__ + "img/checkmark-gray.ecc60bf8.svg";